import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import confirmReducer from './confirmSlice';

const store = configureStore({
  reducer: {
    confirm: confirmReducer,
    auth: authReducer,
  },
});

export default store;